import * as yup from "yup";

export const signupSchema = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().email().required(),
  phoneNumber: yup
    .string()
    .required()
    .length(10, "Please Enter a valid Phone number"),
  password: yup
    .string()
    .min(8, ({ min }) => `Password must be at least ${min} characters`)
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{8,}$/,
      () => "Please Enter a valid password"
    )
    .required("Password is required"),
});

export type signupType = yup.InferType<typeof signupSchema>;
